<template>
  <!-- 对齐 App language.dart：AppHeader + 白色 Card（顶部圆角 30）+ 语言列表 item -->
  <div class="language-page">
    <app-header :title="i18n.title"></app-header>

    <div class="language-card">
      <div
        v-for="item in locales"
        :key="item.value"
        class="language-item"
        :class="{ 'is-active': currentLang === item.value }"
        @click="onSelect(item.value)"
      >
        <span class="language-item-label">{{ item.label }}</span>
        <img
          v-if="currentLang === item.value"
          class="language-item-icon"
          src="../../assets/imgs/icon_sel.png"
          alt=""
        />
        <img
          v-else
          class="language-item-icon"
          src="../../assets/imgs/icon_def.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import AppHeader from "../../components/common/AppHeader.vue"
import Locales from "../../utils/locales"

export default {
  components: {
    AppHeader
  },
  data() {
    return {
      // 从 utils/locales.js 取语言列表（与 App 端 Global.languageList 字段一致：countryCode/name/locale）
      locales: Locales
    }
  },
  computed: {
    ...mapState(["lang"]),
    i18n() {
      return this.$t("settings")
    },
    currentLang() {
      return this.lang
    }
  },
  methods: {
    onSelect(value) {
      if (value === this.currentLang) return
      // 对齐 App language.dart _getTranslation：Provider.of<LocaleModel>(context, listen: false).locale = language
      this.$store.commit("lang", value)
      this.$i18n.locale = value
      this.$toast("OK")
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
/* 对齐 App language.dart：白底 page + 白色 Card（顶部圆角 30 + 30.w 顶部 padding）+ 语言 item */
.language-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.language-card {
  background: #fff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  margin-top: 17px;
  /* 30.w 顶部留白 ≈ 52px（App language.dart L34 padding: EdgeInsets.only(top: 40)） */
  padding: 52px 0 30px;
}

/* item: 56.w 高 ≈ 98px, 30.w 水平 margin ≈ 52px, 15.w 顶部 margin ≈ 26px, 圆角 10 ≈ 17px */
.language-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 98px;
  margin: 0 52px 26px;
  padding: 0 28px; /* 15.w 水平 padding ≈ 26px */
  background: #f8f6fc;
  border: 1px solid #f8f6fc;
  border-radius: 17px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Montserrat-Medium", sans-serif;
}

.language-item-label {
  font-size: 32px;
  font-weight: 500;
  color: #000;
  flex: 1;
}

.language-item-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: block;
}

.language-item.is-active {
  /* 选中态: 整行不变色，仅右侧 icon 切换（与 App language.dart 一致） */
}
</style>
